import { initializers } from '../compat/core'
import redirect from '../components/modules/redirect'
import userAssignment from '../components/modules/userAssignment'
import switcher from '../components/switcher'
import changeFormAction from '../components/modules/changeFormAction'
import radioButtonDisableShareWithLabel from '../components/radioButtonDisableShareWithLabel'
import measurementTypeParameterSelect from '../components/modules/measurementTypeParameterSelect'
import closeModalOnValidationPassed from '../components/modules/closeModalOnValidationPassed'
import remoteModal from '../components/modules/remoteModal'
import select2Templates from './select2-templates'
import fireOnHide from './fire-on-hide'
import spectrumColorPicker from '../components/modules/spectrumColorPicker'
import goToTopButton from '../components/modules/goToTopButton'

import { popperInitializer } from '../components/initializers/popper-tooltip'
import { warningThresholdEvaluatorInitializer } from '../components/initializers/warning-threshold-evaluator'
import { visibleOnSelect } from '../components/initializers/visible-on-select'
import { pdfJsInitializer} from '../components/initializers/pdf-js'

export default [
    initializers.confirm,
    initializers.ajax,
    initializers.tooltip,
    initializers.datepicker,
    initializers.autoQuery,
    initializers.dispatchAction,
    initializers.notify,
    initializers.clickOnEnter,
    visibleOnSelect,
    popperInitializer,
    pdfJsInitializer,
    warningThresholdEvaluatorInitializer,
    redirect,
    userAssignment,
    switcher,
    changeFormAction,
    radioButtonDisableShareWithLabel,
    measurementTypeParameterSelect,
    closeModalOnValidationPassed,
    remoteModal,
    select2Templates,
    fireOnHide,
    spectrumColorPicker,
    goToTopButton
]
